<odx-area-header class="header">
  @if (!hideBackArrow) {
    <button (click)="onNavigateBack()" class="back-button" odxNavigationBack></button>
  }

  @if ((isMobile$ | async) === false) {
    <ng-container>
      <span data-testid="projectDetails.header.projectName">{{ project.name }}</span>

      @if ((isReadOnlyUser$ | async) === true) {
        <odx-chip class="read-access-chip" removable="false" variant="secondary" i18n="@@chip.readOnly">
          <odx-icon name="view" alignleft></odx-icon> Lesemodus
        </odx-chip>
      }

      <odx-area-header-subtitle>
        <span>{{ localizedLastModified }}</span>
        @if ((isReadOnlyUser$ | async) === false) {
          <span class="cloud-save">
            <odx-icon name="cloud" inline> </odx-icon>
            <span>{{ localizedLastCloudSync }}</span>
          </span>
        }
      </odx-area-header-subtitle>
    </ng-container>
  } @else {
    <div odxLayout="flex gap-small align-center" class="mobile-header-container">
      <span data-testid="projectDetails.header.projectName">{{ project.name }}</span>
      <odx-icon name="info" [odxTooltip]="infoTooltip" odxTooltipSize="medium" [odxTooltipOptions]="{ position: 'bottom' }" />
      @if ((isReadOnlyUser$ | async) === false) {
        <button
          odxButton
          [odxMenu]="menu"
          variant="secondary"
          odxMenuPosition="bottom-end"
          data-testid="btn.export"
          class="mobile-export-btn"
        >
          <span i18n="@@projectDetailHeader.button.export">Exportieren</span>
          <odx-icon name="chevron-down" alignRight></odx-icon>
        </button>
      }
    </div>
  }
  @if ((isMobile$ | async) === false) {
    <odx-area-header-content>
      @if ((isReadOnlyUser$ | async) === false) {
        <odx-action-group>
          <button odxButton [odxTooltip]="copyProjectLinkTooltip" (click)="copyProjectLink()">
            <odx-icon name="copy-content" size="medium" alignleft></odx-icon>
            <span i18n="@@project.btn.shareLink">Teilbaren Link kopieren</span>
          </button>
          <button odxButton [odxMenu]="menu" odxMenuPosition="bottom-end" data-testid="btn.export">
            <span i18n="@@projectDetailHeader.button.export">Exportieren</span>
            <odx-icon name="chevron-down" size="medium" alignRight></odx-icon>
          </button>
        </odx-action-group>
      }
    </odx-area-header-content>
  }
</odx-area-header>

<ng-template #infoTooltip>
  <div>{{ localizedLastModified }}</div>
  <div>{{ localizedLastCloudSync }}</div>
</ng-template>

<ng-template #menu>
  <odx-menu>
    <button odxButton odxMenuItem (click)="exportProductList(project)" data-testid="btn.exportProductList">
      <odx-icon name="export" size="medium" alignLeft></odx-icon>
      <span i18n="@@projectDetailHeader.button.exportProductList">Produktliste exportieren</span>
    </button>
    @if (!floorplanExportEnabled) {
      <button odxButton odxMenuItem (click)="exportProjectToPdf(project)" data-testid="btn.exportProjectAsPdf">
        <odx-icon name="file-pdf" size="medium" alignLeft></odx-icon>
        <span i18n="@@projectDetailHeader.button.exportProjectPdf">Projekt als PDF exportieren</span>
      </button>
    }
    @if (floorplanExportEnabled) {
      <button odxButton odxMenuItem (click)="exportFloorplanToPdf()" data-testid="btn.exportFloorplanAsPdf">
        <odx-icon name="file-pdf" size="medium" alignLeft></odx-icon>
        <span i18n="@@projectDetailHeader.button.exportFloorplanPdf">Grundrissplan als PDF exportieren</span>
      </button>
    }

    <button
      odxButton
      odxMenuItem
      [disabled]="!navigator.onLine || (hasWritePermission$ | async) === false"
      (click)="$event.stopPropagation(); openShareLinkModal()"
    >
      <odx-icon name="link" size="medium" alignleft></odx-icon>
      <span i18n="@@projectCard.button.shareProjectLink">Lesefreigabe erteilen</span>
    </button>
  </odx-menu>
</ng-template>
